import { Box, styled } from "@mui/material";
import { colors } from '../../../../theme/colors';

export const MainContainer = styled(Box)({
  padding: "24px",
  background: "#f4f6f8",
  minHeight: "100%",

  "& .page-card": {
    background: "#ffffff",
    border: "1px solid #dde7f0",
    borderRadius: "20px",
    padding: "28px",
    boxShadow: "0 10px 30px rgba(127, 29, 29, 0.08)",
    maxWidth: "1000px",
  },

  "& .page-header": {
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "1px solid #e8eef5",
  },

  "& .page-title": {
    fontSize: "28px",
    fontWeight: 700,
    color: colors.primary,
    lineHeight: 1.2,
    marginBottom: "6px",
  },

  "& .page-subtitle": {
    fontSize: "14px",
    color: "#637381",
    lineHeight: 1.5,
  },

  "& .form-grid": {
    marginTop: "8px",
  },

  "& .field-block": {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  "& .field-label": {
    fontSize: "14px",
    fontWeight: 600,
    color: colors.primary,
    marginBottom: "2px",
  },

  "& .form-actions": {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "28px",
    paddingTop: "20px",
    borderTop: "1px solid #e8eef5",
  },

  "& .btn": {
    minWidth: "170px",
    height: "48px",
    borderRadius: "12px",
    backgroundColor: colors.primary,
    textTransform: "none",
    color: "#fff",
    fontWeight: 600,
    fontSize: "15px",
    boxShadow: "0 8px 18px rgba(127, 29, 29, 0.18)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      color: "#fff",
      boxShadow: "0 10px 22px rgba(127, 29, 29, 0.22)",
    },
    "&.updating-btn": {
      cursor: "not-allowed",
      opacity: 0.9,
    },
    "&.Mui-disabled": {
      backgroundColor: colors.buttonDisabled.background,
      color: colors.buttonDisabled.color,
      opacity: 1,
      cursor: "not-allowed",
    },
  },

  "& .cancel-btn": {
    minWidth: "120px",
    height: "48px",
    borderRadius: "12px",
    backgroundColor: "transparent",
    textTransform: "none",
    color: colors.primary,
    fontWeight: 600,
    fontSize: "15px",
    border: "1.5px solid #d6e0ea",
    boxShadow: "none",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primaryLight,
      borderColor: colors.primary,
      boxShadow: "none",
    },
  },

  "& .MuiCircularProgress-root": {
    marginLeft: "8px",
  },

  "& .required_field": {
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      backgroundColor: "#fff",
      transition: "all 0.2s ease",
      "& fieldset": {
        borderColor: "#d6e0ea",
      },
      "&:hover fieldset": {
        borderColor: colors.primary,
      },
      "&.Mui-focused fieldset": {
        borderColor: colors.primary,
        borderWidth: "1.5px",
      },
      "&.Mui-disabled": {
        backgroundColor: "#f5f7fa",
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#e0e0e0",
        },
      },
    },
    "& .MuiInputLabel-root": {
      color: "#637381",
      "&.Mui-focused": {
        color: colors.primary,
      },
    },
  },

  "& .role-menu-item": {
    borderRadius: "8px",
    margin: "4px 8px",
    "&:hover": {
      backgroundColor: `${colors.primary} !important`,
      color: "#fff",
    },
  },

  "& .custom-phone-input": {
    "& input": {
      width: "100% !important",
      height: "56px",
      borderRadius: "12px",
      border: "1px solid #d6e0ea",
      paddingLeft: "48px",
      fontSize: "14px",
      transition: "all 0.2s ease",
      boxSizing: "border-box",
      "&:focus": {
        borderColor: colors.primary,
        boxShadow: "0 0 0 2px rgba(127, 29, 29, 0.08)",
        outline: "none",
      },
      "&:disabled": {
        backgroundColor: "#f5f5f5",
        cursor: "not-allowed",
      },
    },

    "& .flag-dropdown": {
      borderTopLeftRadius: "12px !important",
      borderBottomLeftRadius: "12px !important",
      border: "1px solid #d6e0ea !important",
      backgroundColor: "#fff !important",
    },
  },

  "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "#fff",
    "& fieldset": {
      borderColor: "#d6e0ea",
    },
    "&:hover fieldset": {
      borderColor: colors.primary,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.primary,
      borderWidth: "1.5px",
    },
  },

  "& .MuiFormHelperText-root": {
    marginLeft: "2px",
  },

  "@media (max-width: 900px)": {
    padding: "16px",

    "& .page-card": {
      padding: "20px",
      borderRadius: "16px",
    },

    "& .page-title": {
      fontSize: "24px",
    },

    "& .form-actions": {
      justifyContent: "stretch",
    },

    "& .btn": {
      width: "100%",
    },

    "& .cancel-btn": {
      width: "100%",
    },
  },
});

export const LoadingContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
});
